import { render } from "./InstrucoesCarregamentoPedidoEmAndamentoPDF.vue?vue&type=template&id=20cad264&scoped=true"
import script from "./InstrucoesCarregamentoPedidoEmAndamentoPDF.vue?vue&type=script&lang=js"
export * from "./InstrucoesCarregamentoPedidoEmAndamentoPDF.vue?vue&type=script&lang=js"

import "./InstrucoesCarregamentoPedidoEmAndamentoPDF.vue?vue&type=style&index=0&id=20cad264&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cad264"]])

export default __exports__